module.exports = __webpack_public_path__ + "html/related-pages_85529654099b8c050eae5a729cc7f445.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/related-pages.html
// module id = kmnB
// module chunks = 153